import { FC } from 'react';
import { DoorScreenDisplayType, doorScreenDisplayType, locationStatus } from '../../../enums';
import '../../../styles/workplace.scss';
import { IDoorScreenlColorsForm } from '../../administration/organization/generalSettings/design/GeneralSettingsDesignDoorScreen';
import DoorScreenManualStateView from './DoorScreenManualStateView';
import DoorSreenPractitionerInfoView from './DoorSreenPractitionerInfoView';
import { IPractitionerWorkTime } from './models';

interface FullViewProps {
    showMain: string;
    blinkProp: boolean;
    ticketState: number | null;
    displayType: DoorScreenDisplayType;
    design: IDoorScreenlColorsForm;
    practitionerToShow: IPractitionerWorkTime | null;
    logo: string | null;
}

const DoorScreenDisplayPageFullView: FC<FullViewProps> = (props: FullViewProps) => {
    const backgroundHandle = () => {
        if (props.ticketState === 2) {
            return 'inviting';
        }
        if (props.ticketState === 3) {
            return 'busy';
        }
        return;
    };

    const textByBackgorund = () => {
        if (backgroundHandle() === 'inviting') {
            return 'Kviečiamas';
        }
        if (backgroundHandle() === 'busy') {
            return 'Užimta';
        }
        return '';
    };

    return (
        <div>
            <div
                className={`fullViewStatusContainer ${backgroundHandle()}`}
                style={{ color: props.design.secondaryColor?.toString(), backgroundColor: props.design.secondaryColor?.toString() }}
            >
                {locationStatus.doesContainValue(props.showMain) ? (
                    <DoorScreenManualStateView primaryColor={props.design.primaryColor} doorStateText={props.showMain}/>
                ) : (
                    <div>
                        {props.showMain === '' ? (
                            props.practitionerToShow && doorScreenDisplayType.Detailed === props.displayType ? (
                                <DoorSreenPractitionerInfoView design={props.design} practitionerToShow={props.practitionerToShow} />
                            ) : (
                                props.logo && <img style={{ maxWidth: '90%', maxHeight: '80%' }} src={`data:image/jpeg;base64,${props.logo}`} alt="Base64" />
                            )
                        ) : (
                            <div>
                                <div className="additionalInformation">{textByBackgorund()}</div>
                                <div className={`primaryInformation ${props.blinkProp && 'blink'}`}>{props.showMain}</div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DoorScreenDisplayPageFullView;
